import { Injectable } from "@angular/core";
import { DateHelpers } from '@edl-development/edl-common';
import { CplCycle } from "src/app/model/cpl-cycle.model";
import { CplItem } from "src/app/model/cpl-item.model";
import { CplRequestItem } from "src/app/model/cpl-request-item.model";
import { TimeTrackingDetail } from "src/app/model/cpl-time-tracking.model";
import { CplUserRequest } from "src/app/model/cpl-user-request.model";
import { ComplianceItemHelpersService } from "src/app/services/compliance-item-helpers/compliance-item-helpers.service";
import { RequestHelpersService } from "src/app/services/request-helpers/request-helpers.service";
import { UserTimeTrackingSubmission } from "../../model/user-time-tracking-form/user-time-tracking-submission.model";


@Injectable()
export class TimeTrackingHelperService {

    constructor(
        private complianceItemHelpersService: ComplianceItemHelpersService,
        private requestHelpersService: RequestHelpersService
    ) {}

    getUserCycleDisplayHours = (userCycle: CplCycle, complianceItem: CplItem) => {
        return userCycle?.UserTimeTracking?.Hours
            ?? userCycle?.FlexHours
            ?? (this.complianceItemHelpersService.isFinalUserStatus(userCycle?.UserStatus) ? 0 : complianceItem?.FlexDetails?.Hours)
            ?? 0
    }

    getUserRequestDisplayHours = (userRequest: CplUserRequest, requestItem: CplRequestItem) => {
        var isCompleted = this.requestHelpersService.isFinalUserStatus(userRequest?.UserStatus);
        return this.getValueOrDefault('Hours', isCompleted, userRequest?.FlexDetails, requestItem?.FlexDetails, 0)
    }

    getTimeTrackingDetailOrDefault(isComplete: boolean, userTimeTrackingDetails: TimeTrackingDetail, itemTimeTrackingDetails: TimeTrackingDetail): UserTimeTrackingSubmission {
       const EventStartDate = this.getValueOrDefault('EventStartDate', isComplete, userTimeTrackingDetails, itemTimeTrackingDetails, undefined);
       const EventEndDate = this.getValueOrDefault('EventEndDate', isComplete, userTimeTrackingDetails, itemTimeTrackingDetails, undefined);
       
        return {
            Hours: this.getValueOrDefault('Hours', isComplete, userTimeTrackingDetails, itemTimeTrackingDetails, 0),
            Confirmed: this.getValueOrDefault('Confirmed', isComplete, userTimeTrackingDetails, itemTimeTrackingDetails, false),
            EventName: this.getValueOrDefault('EventName', isComplete, userTimeTrackingDetails, itemTimeTrackingDetails, undefined),
            EventStartDate: DateHelpers.isMinDate(EventStartDate) ? undefined : EventStartDate,
            EventEndDate: DateHelpers.isMinDate(EventEndDate) ? undefined : EventEndDate
        }
    }

    getValueOrDefault(key: keyof TimeTrackingDetail, isComplete: boolean, userTimeTrackingDetails: TimeTrackingDetail, itemTimeTrackingDetails: TimeTrackingDetail, defaultValue: any) {
        return userTimeTrackingDetails?.[key]
            ?? (this.canUseDefaultValues(isComplete, itemTimeTrackingDetails) ? itemTimeTrackingDetails?.[key] : defaultValue)
            ?? defaultValue;
    }

    private canUseDefaultValues(isComplete: boolean, itemTimeTrackingDetails: TimeTrackingDetail): boolean {
        const isApplicable = itemTimeTrackingDetails?.Applicable ?? false;

        return isApplicable && !isComplete;
    }
}
